document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('BoutiqueForm');
    
    // Function mở Popup
    window.openAppointmentModal = function(e,type) {
        e.preventDefault();
        let modal = document.querySelector('.appointment-modal[data-type="'+type+'"]');
      if (modal) {
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    };

    // Function đóng Popup
    window.closeAppointmentModal = function(type) {
        let modals = document.querySelectorAll('.appointment-modal');
      modals.forEach(modal =>{
          modal.classList.remove('is-active');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
      })
    };

    window.submitAppointmentForm = (e,type) => {
        let subject;
        switch (type) {
            case 'custom_fit':
                subject = 'Custom fit'
                break;
            case 'bespoke':
                subject = 'Bespoke'
                break;
            case 'uniform':
                subject = 'Uniform'
                break;
            default:
                break;
        }
        e.preventDefault();
        let formData = new FormData(e.target);
        try {
            fetch('https://e83b-14-232-245-194.ngrok-free.app/email/send',{
                method: 'POST', // 1. Specify the HTTP method
                headers: {
                'Content-Type': 'application/json', // 2. Tell the server you are sending JSON
                // 'Authorization': 'Bearer YOUR_TOKEN' // Add auth headers here if needed
                },
                body: JSON.stringify({
                subject: subject,
                fields: Object.fromEntries(formData.entries())
                })
            })
        } catch (error) {
            console.log(error)
        }
    }

    // Gán sự kiện click nút đóng
    document.querySelectorAll('[data-appointment-close]').forEach(button => {
      button.addEventListener('click', closeAppointmentModal);
    });

    // Đóng bằng phím ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeAppointmentModal();
      }
    });
    
  });